import { render, staticRenderFns } from "./CreateProvider.vue?vue&type=template&id=131e62b6&scoped=true"
import script from "./CreateProvider.vue?vue&type=script&lang=js"
export * from "./CreateProvider.vue?vue&type=script&lang=js"
import style0 from "./CreateProvider.vue?vue&type=style&index=0&id=131e62b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131e62b6",
  null
  
)

export default component.exports